export default __webpack_public_path__ + "static/media/mint.c3841791.gif";